module.exports = __webpack_public_path__ + "img/Frame_43.c592eb74.png";